import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

/** 域名拦截排行请求参数 */
export interface DomainRankingRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time?: string
  /** 结束时间（时间戳，单位：秒） */
  end_time?: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

/** 域名拦截排行响应 */
export interface DomainRankingItem {
  domain: string
  block_count: number
}

export interface DomainRankingResponseData {
  top_domain_list: DomainRankingItem[]
}

/** IP拦截排行请求参数 */
export interface IpRankingRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time?: string
  /** 结束时间（时间戳，单位：秒） */
  end_time?: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

/** IP拦截排行响应 */
export interface IpRankingItem {
  ip_address: string
  block_count: number
}

export interface IpRankingResponseData {
  top_ip_list: IpRankingItem[]
}

/** 风险端口排行请求参数 */
export interface PortRankingRequestParams {
  /** 排行数量（默认TOP5） */
  top_count?: number
}

/** 风险端口排行响应 */
export interface PortRankingItem {
  port_num: number
  risk_detail?: string
  device_count?: number,
  system_type:number
}

export interface PortRankingResponseData {
  port_list: PortRankingItem[]
}

/** 终端流量排行请求参数 */
export interface TrafficRankingRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time?: string
  /** 结束时间（时间戳，单位：秒） */
  end_time?: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

/** 终端流量排行响应 */
export interface TrafficRankingItem {
  computer_name: string
  department: string
  total_flow: string | number
}

export interface TrafficRankingResponseData {
  top_terminal_list: TrafficRankingItem[]
}

/** 上网分类占比请求参数 */
export interface CategoryProportionRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time?: string
  /** 结束时间（时间戳，单位：秒） */
  end_time?: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

/** 上网分类占比响应 */
export interface CategoryProportionItem {
  category_name: string
  ratio: number
}

export interface CategoryProportionResponseData {
  top_category_list: CategoryProportionItem[]
}

@Injectable()
export class OnlineControlZoneService {
  constructor(private http: Http) {}

  /** 获取域名拦截排行 */
  @InvokeThrottle()
  getDomainRanking(params: DomainRankingRequestParams) {
    return this.http.post<DomainRankingResponseData>('/terminal/domainaccess/top-domain-stat', {
      top_count: params.top_count || 5,
      start_time: params.start_time,
      end_time: params.end_time
    })
  }

  /** 获取IP拦截排行 */
  @InvokeThrottle()
  getIpRanking(params: IpRankingRequestParams) {
    return this.http.post<IpRankingResponseData>('/terminal/ipaccess/top-ip-stat', {
      top_count: params.top_count || 5,
      start_time: params.start_time,
      end_time: params.end_time
    })
  }

  /** 获取风险端口排行 */
  @InvokeThrottle()
  getPortRanking(params: PortRankingRequestParams) {
    return this.http.post<PortRankingResponseData>('/portcontrol/top-risk/get', {
      top_count: params.top_count || 5
    })
  }

  /** 获取终端流量排行 */
  @InvokeThrottle()
  getTrafficRanking(params: TrafficRankingRequestParams) {
    return this.http.post<TrafficRankingResponseData>('/safemonitor/flow-top-terminal-stat', {
      top_count: params.top_count || 5,
      start_time: params.start_time,
      end_time: params.end_time
    })
  }

  /** 获取上网分类占比 */
  @InvokeThrottle()
  getCategoryProportion(params: CategoryProportionRequestParams) {
    return this.http.post<CategoryProportionResponseData>('/terminal/domainaccess/top-category-stat', {
      top_count: params.top_count || 5,
      start_time: params.start_time,
      end_time: params.end_time
    })
  }
}
